/* @flow */
import Entity from 'lib/Entity';
import { cloneDeep } from 'lodash';
import Reactions from 'collections/Reactions';

export default class ReactionSummary extends Entity {
  defaults() {
    return {
      version: 0,
      reactions: new Reactions(),
    };
  }

  parse(response: Object): Object {
    const reactionSummary = cloneDeep(response);

    reactionSummary['reactions'] = Reactions.fromJSON(reactionSummary['reactions']);

    return reactionSummary;
  }

  getReactions(): Reactions {
    return this.get('reactions');
  }

  getVersion(): number {
    return this.get('version');
  }

  getMessageUuid(): string {
    return this.get('message_uuid');
  }

  toGraphQL(): ReactionSummaryGQL {
    return {
      __typename: 'ReactionSummary',
      reactions: this.getReactions().map(r => r.toGraphQL()),
      version: this.getVersion(),
      messageUuid: this.getMessageUuid(),
    };
  }
}
